import { FC } from 'react'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

/** Loading placeholder mirroring the conversation list item layout during the initial fetch. */
export const ConversationListSkeleton: FC = () => {
  return (
    <Stack gap="0.8rem" padding="0.8rem">

      {Array.from({ length: 6 }).map((_, index) => (
        <Stack key={index} gap="0.6rem" padding="1.2rem">

          <Stack direction="row" justifyContent="space-between" alignItems="center">

            <Skeleton variant="text" width="50%" height="2rem" />

            <Skeleton variant="text" width="3rem" height="1.6rem" />

          </Stack>

          <Skeleton variant="text" width="90%" height="1.6rem" />

          <Skeleton variant="text" width="70%" height="1.6rem" />

        </Stack>
      ))}

    </Stack>
  )
}
